import { colors } from "@mui/material";

const white = "#FFFFFF";
const black = "#000000";
const padrao = { main: "#d5d5d5" };
const topbar = "#EB5757";

export const cinza = {
  50: "#F5F6F6",
  100: "#E8EAEB",
  200: "#D1D4D6",
  300: "#B2B6BA",
  400: "#8B9196",
  500: "#6B7176",
  600: "#51565B",
  700: "#43474B",
  800: "#33373A",
  900: "#212426",
};

export default {
  black,
  white,
  padrao,
  topbar,
  cinza,
  primary: {
    contrastText: white,
    dark: cinza[600],
    main: cinza[500],
    light: cinza[400],
  },
  secondary: {
    contrastText: white,
    main: cinza[900],
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400],
  },
  info: {
    contrastText: white,
    dark: cinza[900],
    main: cinza[600],
    light: cinza[400],
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400],
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    primary: cinza[900],
    secondary: cinza[600],
    link: cinza[600],
  },
  background: {
    default: "#F5F5F5",
    paper: white,
  },
  icon: cinza[600],
  divider: colors.grey[300],
};
